import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect, NavLink } from 'react-router-dom';
import axios from '../../../_services/api/axios';
import withErrorHandler from '../../../_hoc/withErrorHandler';
import * as actionCreators from '../../../_store/actions/index';
import Aux from '../../../_hoc/_Aux';
import { getTranslate } from 'react-localize-redux';
import ReactTooltip from 'react-tooltip'
import * as FormHelpers from '../../../_helpers/Form.js';
import {toastr} from 'react-redux-toastr'

import { PageTemplate, Header, PageTitle, Box, Form, GreyBox, Wizard, Flex, Toggle, InputRow, Input, Select, Button, Spacer, Text } from 'components'

class MachinesNewPage extends Component {
	defaultFormState = {
        name : {
            state : false,
            message : false
        },
        multihead : {
            state : false,
            message : false
        },
        heads : {
            state : false,
            message : false
        },
        investment : {
            state : false,
            message : false
        },
        amortization_months : {
            state : false,
            message : false
        },
        speed : {
            state : false,
            message : false
        },
        color_change_time : {
            state : false,
            message : false
        },
        bobbin_stitch_count : {
            state : false,
            message : false
        },
        bobbin_change_time : {
            state : false,
            message : false
        },
        stitches_next_thread_break : {
            state : false,
            message : false
        },
        thread_break_fixing_time : {
            state : false,
            message : false
        },
        hoop_change_time : {
            state : false,
            message : false
        },
        trimming_time : {
            state : false,
            message : false
        },
        cone_change_time : {
            state : false,
            message : false
        },
        maintenance_cost : {
            state : false,
            message : false
        }
    }
    defaultMessageState = {
        show : false,
        message : null
    }
    constructor(props) {
        super(props);
        this.state = {
	        form : {
	            name : "",
	            multihead : false,
	            heads: 1,
	            investment: 0,
	            amortization_months: 0,
	            speed: 0,
	            color_change_time: 0,
	            bobbin_stitch_count: 0,
	            bobbin_change_time: 0,
	            stitches_next_thread_break: 0,
	            thread_break_fixing_time: 0,
	            hoop_change_time: 0,
	            trimming_time: 0,
                cone_change_time: 0,
                maintenance_cost: 0
	        },
	        form_state: this.defaultFormState,
            message : this.defaultMessageState,
            form_blocked: false,
            willSubmit: false,
	        wizard : {
	        	steps : [{
	        		name : this.props.translate('machinenewpage.step_1.name'),
	        		active : true
	        	},{
	        		name : this.props.translate('machinenewpage.step_2.name'),
	        		active : false
	        	}]
	        }
		}
	}

    componentDidMount = () => {
        this.props.onFetchMachinesDefaults();
    }

    componentWillUnmount = () => {
    	this.props.onResetMachine();
        this.props.onCalculatorMachineDuplicateCheckReset();
    }

    componentDidUpdate = (prevProps, prevState, snapshot) => {
    	if(prevProps.calculatorMachinesDefaults !== this.props.calculatorMachinesDefaults) {
	        this.defaultValueHandler();  		
	    }
        if(prevProps.defaults !== this.props.defaults) {
            this.setState(prevState => ({
                wizard : {
                    ...prevState.wizard,
                    steps : [{
                        name : this.props.translate('machinenewpage.step_1.name'),
                        active : true
                    },{
                        name : this.props.translate('machinenewpage.step_2.name'),
                        active : false
                    }]
                }
            }))            
        }
        //Duplicate Check
        if(!prevProps.state.name_checked && this.props.state.name_checked) {
            this.setState(prevState => ({
                form_blocked: !this.props.state.name_available ? true : false,
                form_state : {
                    ...prevState.form_state,
                    name : {
                        ...prevState.form_state.name,
                        state : this.props.state.name_available ? 'success' : 'error',
                        message : !this.props.state.name_available ? this.props.translate('machinenewpage.error.name_exists') : null
                    }
                }
            }));
            if(this.state.willSubmit) {
                this.setState(prevState => ({
                    willSubmit : false
                }), () => {
                    if(this.props.state.name_available) {
                        this.submitHandler();
                    }
                });
            }
        }
	    if(prevProps.state.error !== this.props.state.error && this.props.state.error && this.props.state.error.length && this.props.state.error[0].key.toLowerCase() !== 'last') {
            if(this.props.state.error.length) {
                this.setState(prevState => ({
                    form_state: this.defaultFormState
                }), () => {
                    this.props.state.error.forEach((error, index) => {
                        if(this.state.form_state[error.source]) {
                            this.setState(prevState => ({
                                form_state : {
                                    ...prevState.form_state,
                                    [error.source] : {
                                        state : 'error',
                                        message : this.props.translate('global.error.'+error.key.toLowerCase()+'.'+error.source.toLowerCase(),null,{missingTranslationMsg: error.message})
                                    }
                                }
                            }))
                        }
                    })
                });
            }
            if(this.props.state.error.length === 1) {
                this.setState(prevState => ({
                    message: {
                        message: this.props.translate('machinenewpage.error.'+this.props.state.error[0].key.toLowerCase(),null,{missingTranslationMsg: this.props.translate('machinenewpage.error.default')}),
                        type: "error"
                    }
                }));

            }
            else {
                this.setState(prevState => ({
                    message: {
                        message: this.props.translate('machinenewpage.error.default'),
                        type: "error"
                    }
                }));
            }
        }
        if(this.props.state.created) {
            toastr.success(this.props.translate('machinespage.success.created.title'), this.props.translate('machinespage.success.created.text')); 
        }
    }

    defaultValueHandler = (event) => {
    	if(event) {
    		var configPos = event.target.value - 1;
    	}
    	else {
    		var configPos = 0;
    	}
    	if(this.props.calculatorMachinesDefaults.machines[configPos]) {
    		this.setState(prevState => ({
	    		form: {
		            ...prevState.form,
		            multihead : this.props.calculatorMachinesDefaults.machines[configPos].multihead,
		            heads: this.props.calculatorMachinesDefaults.machines[configPos].heads,
		            amortization_months: this.props.calculatorMachinesDefaults.machines[configPos].amortization_months,
		            speed: this.props.calculatorMachinesDefaults.machines[configPos].settings.speed,
		            color_change_time: this.props.calculatorMachinesDefaults.machines[configPos].settings.color_change_time,
		            bobbin_stitch_count: this.props.calculatorMachinesDefaults.machines[configPos].settings.bobbin_stitch_count,
		            bobbin_change_time: this.props.calculatorMachinesDefaults.machines[configPos].settings.bobbin_change_time,
		            stitches_next_thread_break: this.props.calculatorMachinesDefaults.machines[configPos].settings.stitches_next_thread_break,
		            thread_break_fixing_time: this.props.calculatorMachinesDefaults.machines[configPos].settings.thread_break_fixing_time,
		            hoop_change_time: this.props.calculatorMachinesDefaults.machines[configPos].settings.hoop_change_time,
		            trimming_time: this.props.calculatorMachinesDefaults.machines[configPos].settings.trimming_time,
		            cone_change_time: this.props.calculatorMachinesDefaults.machines[configPos].settings.cone_change_time,
                    maintenance_cost: this.props.calculatorMachinesDefaults.machines[configPos].settings.maintenance_cost
	    		}
	    	}))
			
		}
    }

    newMachineHandler = ( event ) => {
        event.preventDefault();
        if(this.state.wizard.steps[0].active) {
            if(this.props.state.name_checked && this.props.state.name_available) {
                this.submitHandler();
            }
            else {
                this.setState(prevState => ({
                    willSubmit : true
                }), () => {
                    this.duplicateCheckHandler(); 
                });
            }
        }
        else {
            this.submitHandler();
        }
    }

    inputChangedToggle = (value, inputIdentifier) => {
    	this.setState(prevState => ({
            form: {
                ...prevState.form,
                [inputIdentifier]: value
            }
        }));
    }

    inputChangedHandler = (event, inputIdentifier) => {
        let value = event.target.value;
        this.setState(prevState => ({
            form: {
                ...prevState.form,
                [inputIdentifier]: value
            }
        }));
        if(inputIdentifier === "heads") {
        	this.defaultValueHandler( event );
        }
    }

    inputBlurredHandler = (event, inputIdentifier) => {
        if(inputIdentifier === 'name') {
            this.duplicateCheckHandler();
        }
        FormHelpers.validateFields.apply(this,[[inputIdentifier]]);
        if(this.refs[inputIdentifier + "InputRow"]) {
            this.refs[inputIdentifier + "InputRow"].hideTooltip();
        }
    }
    inputFocusHandler = (event, inputIdentifier) => {
        if(this.refs[inputIdentifier + "InputRow"]) {
            this.refs[inputIdentifier + "InputRow"].showTooltip();
        }
    }

    duplicateCheckHandler = () => {
        if(this.state.wizard.steps[0].active) {
            if(this.refs.name.props.value.length) {
                this.setState(prevState => ({
                    form_blocked: true,
                    form_state : {
                        ...prevState.form_state,
                        name : {
                            ...prevState.form_state.name,
                            state : 'loading'
                        }
                    }
                }), () => {
                    this.props.onCalculatorMachineDuplicateCheck({name: this.refs.name.props.value});
                });
            }
            else {
                this.setState(prevState => ({
                    form_blocked: false,
                    form_state : {
                        ...prevState.form_state,
                        name : {
                            ...prevState.form_state.name,
                            state : false
                        }
                    }
                }), () => {
                    this.submitHandler();
                });
            }
        }
        else if(this.state.willSubmit) {
            this.submitHandler();            
        }
    }

    submitHandler = ( event ) => {
        this.setState(prevState => ({
            message: this.defaultMessageState
        }));
        const formData = {
            name : this.state.form.name,
            heads: Number.parseInt(this.state.form.heads),
            multihead: this.state.form.multihead,
            investment: Number.parseInt(this.state.form.investment),
            amortization_months: Number.parseInt(this.state.form.amortization_months),
            settings: {
                speed: Number.parseInt(this.state.form.speed),
                color_change_time: Number.parseInt(this.state.form.color_change_time),
                bobbin_stitch_count: Number.parseInt(this.state.form.bobbin_stitch_count),
                bobbin_change_time: Number.parseInt(this.state.form.bobbin_change_time),
                stitches_next_thread_break: Number.parseInt(this.state.form.stitches_next_thread_break),
                thread_break_fixing_time: Number.parseInt(this.state.form.thread_break_fixing_time),
                hoop_change_time: Number.parseInt(this.state.form.hoop_change_time),
                trimming_time: Number.parseInt(this.state.form.trimming_time),
                cone_change_time: Number.parseInt(this.state.form.cone_change_time),
                maintenance_cost: Number.parseInt(this.state.form.maintenance_cost)
            }
        };
        //Step 1
        if(this.state.wizard.steps[0].active) {
            this.setState(prevState => ({
                    willSubmit : false
                }), () => {
                    if(FormHelpers.validateFields.apply(this,[['name','investment','amortization_months']])) {
                        let steps = [...this.state.wizard.steps];
                        steps[1].active = true;
                        steps[0].active = false;
                        this.setState(prevState => ({
                            message: {
                                ...prevState.message,
                                show : false
                            },
                            wizard: {
                                ...prevState.wizard,
                                steps: steps
                            }
                        }), () => ReactTooltip.rebuild());
                    }
                    else {
                        this.setState(prevState => ({
                            message: {
                                show: true,
                                message: this.props.translate('machinenewpage.error.default'),
                                type: "error"
                            }
                        }))                
                    }
                }
            );
        }
        else if(this.state.wizard.steps[1].active) {
            this.setState(prevState => ({
                    willSubmit : false
                }), () => {
                    if(FormHelpers.validateFields.apply(this,[['speed','color_change_time','bobbin_stitch_count','bobbin_change_time','stitches_next_thread_break','thread_break_fixing_time','hoop_change_time','trimming_time','cone_change_time','maintenance_cost']])) {
                        this.props.onCreateMachine(formData);
                    }
                    else {
                        this.setState(prevState => ({
                            message: {
                                show: true,
                                message: this.props.translate('machinenewpage.error.default'),
                                type: "error"
                            }
                        }))                
                    }
                }
            );
        }
    }


    timesIterator = n => f => {
      let iter = i => {
        if (i === n) return
        f (i)
        iter (i + 1)
      }
      return iter (0)
    }
    
	render() {
        let headConfig = [];
        this.timesIterator (20) (i => {
            headConfig.push({
                value: i+1,
                name: (i+1) + " " + this.props.translate('global.machine.head.multiple')
            })
        })

        var showMessage;
        if(this.state.message.message) {
            showMessage = this.state.message
        }
	  	return (
	  		<Aux>
                {this.props.state.created ? (<Redirect to='/machines' />) : (
				    <PageTemplate header={<Header />}>
				      <Form onSubmit={this.newMachineHandler}>
		                    {this.state.wizard.steps[0].active ? (
				            <GreyBox title={this.props.translate('machinenewpage.title')} msg={showMessage} steps={this.state.wizard.steps}>
			                    <InputRow label={this.props.translate('global.form.label.machine.name')} 
                                            ref="nameInputRow"
                                            state={this.state.form_state.name.state ? this.state.form_state.name.state : null} 
                                            tip={this.state.form_state.name.message ? this.state.form_state.name.message : null}>
			                        <Input 
			                            identifier="name"
                                        ref="name"
			                            type="text"
			                            value={this.state.form.name}
			                            changed={this.inputChangedHandler}
                                        blurred={this.inputBlurredHandler}
                                        focused={this.inputFocusHandler}
                                        maxlength={50}
                                        isRequired={true} />
			                    </InputRow>
				                <Flex break="xs">
				                    <InputRow 	label={this.props.translate('global.form.label.machine.heads')} 
                                                cols="2" 
                                                ref="headsInputRow"
                                                state={this.state.form_state.heads.state ? this.state.form_state.heads.state : null} 
                                                tip={this.state.form_state.heads.message ? this.state.form_state.heads.message : null}
                                                hint={this.props.translate('global.help.machine.heads')}>
		    		                    <Select 
		    		                        identifier="heads"
                                            ref="heads"
		    		                        options={headConfig}
		    		                        value={this.state.form.heads}
		    		                        changed={this.inputChangedHandler}
                                            blurred={this.inputBlurredHandler}
                                            focused={this.inputFocusHandler}
                                            isRequired={true} />
				                    </InputRow>
				                    <InputRow 	label={this.props.translate('global.form.label.machine.investment')} 
                                                unit={this.props.settingsCompany.settings.currency ? this.props.settingsCompany.settings.currency.symbol : ""} 
                                                cols="2" 
                                                ref="investmentInputRow"
                                                state={this.state.form_state.investment.state ? this.state.form_state.investment.state : null} 
                                                tip={this.state.form_state.investment.message ? this.state.form_state.investment.message : null}
                                                hint={this.props.translate('global.help.machine.investment')}>
				                        <Input 
				                            identifier="investment"
                                            ref="investment"
				                            type="number"
                                            minValue={0}
                                            maxValue={99999999}
				                            value={this.state.form.investment}
				                            changed={this.inputChangedHandler}
                                            blurred={this.inputBlurredHandler}
                                            focused={this.inputFocusHandler}
                                            isRequired={true}/>
				                    </InputRow>
				                </Flex>
			                    <InputRow 	label={this.props.translate('global.form.label.machine.amortization_months')}
                                            unit={this.props.translate('global.units.months')} 
                                            ref="amortization_monthsInputRow"
                                            state={this.state.form_state.amortization_months.state ? this.state.form_state.amortization_months.state : null} 
                                            tip={this.state.form_state.amortization_months.message ? this.state.form_state.amortization_months.message : null}
                                            hint={this.props.translate('global.help.machine.amortization_months')}>
			                        <Input 
			                            identifier="amortization_months"
                                        ref="amortization_months"
			                            type="number"
                                        minValue={0}
                                        maxValue={240}
			                            value={this.state.form.amortization_months}
			                            changed={this.inputChangedHandler}
                                        blurred={this.inputBlurredHandler}
                                        focused={this.inputFocusHandler}
                                        isRequired={true} />
			                    </InputRow>
			                    <InputRow label={this.props.translate('global.form.label.machine.multihead')} 
                                            ref="multiheadInputRow"
                                            theme="light" state={this.state.form_state.multihead.state ? this.state.form_state.multihead.state : null} 
                                            tip={this.state.form_state.multihead.message ? this.state.form_state.multihead.message : null}>
			                        <Toggle 
			                            identifier="multihead"
                                        ref="multihead"
			                            value={this.state.form.multihead}
			                            changed={this.inputChangedToggle}
                                        blurred={this.inputBlurredHandler}
                                        focused={this.inputFocusHandler} />
			                    </InputRow>
			                    <Button data-cy="create-new-machine-continue-btn" value={this.props.translate('machinenewpage.step_1.submit')} type="submit" />
				            </GreyBox>
		                    ) : null }

							{this.state.wizard.steps[1].active ? (
							<GreyBox title={this.props.translate('machinenewpage.title')} msg={showMessage} steps={this.state.wizard.steps}>
			                	<Flex break="xs">
				                	<InputRow 	label={this.props.translate('global.form.label.machine.speed')}  
                                                unit={this.props.translate('global.units.spm')}  
                                                cols="2" 
                                                ref="speedInputRow"
                                                state={this.state.form_state.speed.state ? this.state.form_state.speed.state : null} 
                                                tip={this.state.form_state.speed.message ? this.state.form_state.speed.message : null}
                                            hint={this.props.translate('global.help.machine.speed')}>
				                        <Input 
				                            identifier="speed"
                                            ref="speed"
				                            type="number"
                                            minValue={1}
                                            maxValue={2000}
				                            value={this.state.form.speed}
				                            changed={this.inputChangedHandler}
                                            blurred={this.inputBlurredHandler}
                                            focused={this.inputFocusHandler}
                                            isRequired={true} />
				                    </InputRow>
				                	<InputRow 	label={this.props.translate('global.form.label.machine.color_change_time')}  
                                                unit={this.props.translate('global.units.seconds')}   
                                                cols="2" 
                                                ref="color_change_timeInputRow"
                                                state={this.state.form_state.color_change_time.state ? this.state.form_state.color_change_time.state : null} 
                                                tip={this.state.form_state.color_change_time.message ? this.state.form_state.color_change_time.message : null}
                                            hint={this.props.translate('global.help.machine.color_change_time')}>
				                        <Input 
				                            identifier="color_change_time"
                                            ref="color_change_time"
				                            type="number"
                                            minValue={1}
                                            maxValue={1200}
				                            value={this.state.form.color_change_time}
				                            changed={this.inputChangedHandler}
                                            blurred={this.inputBlurredHandler}
                                            focused={this.inputFocusHandler}
                                            isRequired={true} />
				                    </InputRow>
				                	<InputRow label={this.props.translate('global.form.label.machine.hoop_change_time')}  
                                                unit={this.props.translate('global.units.seconds')}   
                                                cols="2" 
                                                ref="hoop_change_timeInputRow"
                                                state={this.state.form_state.hoop_change_time.state ? this.state.form_state.hoop_change_time.state : null} 
                                                tip={this.state.form_state.hoop_change_time.message ? this.state.form_state.hoop_change_time.message : null}
                                            hint={this.props.translate('global.help.machine.hoop_change_time')}>
				                        <Input 
				                            identifier="hoop_change_time"
                                            ref="hoop_change_time"
				                            type="number"
                                            minValue={1}
                                            maxValue={1200}
				                            value={this.state.form.hoop_change_time}
				                            changed={this.inputChangedHandler}
                                            blurred={this.inputBlurredHandler}
                                            focused={this.inputFocusHandler}
                                            isRequired={true} />
				                    </InputRow>
				                	<InputRow label={this.props.translate('global.form.label.machine.trimming_time')}   
                                                unit={this.props.translate('global.units.seconds')}   
                                                ref="trimming_timeInputRow"
                                                cols="2" state={this.state.form_state.trimming_time.state ? this.state.form_state.trimming_time.state : null} 
                                                tip={this.state.form_state.trimming_time.message ? this.state.form_state.trimming_time.message : null}
                                            hint={this.props.translate('global.help.machine.trimming_time')}>
				                        <Input 
				                            identifier="trimming_time"
                                            ref="trimming_time"
				                            type="number"
                                            minValue={1}
                                            maxValue={1200}
				                            value={this.state.form.trimming_time}
				                            changed={this.inputChangedHandler}
                                            blurred={this.inputBlurredHandler}
                                            focused={this.inputFocusHandler}
                                            isRequired={true} />
				                    </InputRow>
				                	<InputRow label={this.props.translate('global.form.label.machine.cone_change_time')}   
                                                unit={this.props.translate('global.units.seconds')}   
                                                cols="2" 
                                                ref="cone_change_timeInputRow"
                                                state={this.state.form_state.cone_change_time.state ? this.state.form_state.cone_change_time.state : null} 
                                                tip={this.state.form_state.cone_change_time.message ? this.state.form_state.cone_change_time.message : null}
                                            hint={this.props.translate('global.help.machine.cone_change_time')}>
				                        <Input 
				                            identifier="cone_change_time"
                                            ref="cone_change_time"
				                            type="number"
                                            minValue={1}
                                            maxValue={1200}
				                            value={this.state.form.cone_change_time}
				                            changed={this.inputChangedHandler}
                                            blurred={this.inputBlurredHandler}
                                            focused={this.inputFocusHandler}
                                            isRequired={true} />
				                    </InputRow>
				                	<InputRow label={this.props.translate('global.form.label.machine.bobbin_change_time')}   
                                                unit={this.props.translate('global.units.seconds')}   
                                                cols="2" 
                                                ref="bobbin_change_timeInputRow"
                                                state={this.state.form_state.bobbin_change_time.state ? this.state.form_state.bobbin_change_time.state : null} 
                                                tip={this.state.form_state.bobbin_change_time.message ? this.state.form_state.bobbin_change_time.message : null}
                                            hint={this.props.translate('global.help.machine.bobbin_change_time')}>
				                        <Input 
				                            identifier="bobbin_change_time"
                                            ref="bobbin_change_time"
				                            type="number"
                                            minValue={1}
                                            maxValue={1200}
				                            value={this.state.form.bobbin_change_time}
				                            changed={this.inputChangedHandler}
                                            blurred={this.inputBlurredHandler}
                                            focused={this.inputFocusHandler}
                                            isRequired={true} />
				                    </InputRow>
				                </Flex>
			                	<InputRow label={this.props.translate('global.form.label.machine.bobbin_stitch_count')}  
                                            ref="bobbin_stitch_countInputRow"
                                            state={this.state.form_state.bobbin_stitch_count.state ? this.state.form_state.bobbin_stitch_count.state : null} 
                                            tip={this.state.form_state.bobbin_stitch_count.message ? this.state.form_state.bobbin_stitch_count.message : null}
                                            hint={this.props.translate('global.help.machine.bobbin_stitch_count')}>
			                        <Input 
			                            identifier="bobbin_stitch_count"
                                        ref="bobbin_stitch_count"
			                            type="number"
                                        minValue={1}
                                        maxValue={100000}
			                            value={this.state.form.bobbin_stitch_count}
			                            changed={this.inputChangedHandler}
                                        blurred={this.inputBlurredHandler}
                                        focused={this.inputFocusHandler}
                                        isRequired={true} />
			                    </InputRow>
			                	<InputRow label={this.props.translate('global.form.label.machine.stitches_next_thread_break')}   
                                            ref="stitches_next_thread_breakInputRow"
                                            state={this.state.form_state.stitches_next_thread_break.state ? this.state.form_state.stitches_next_thread_break.state : null} 
                                            tip={this.state.form_state.stitches_next_thread_break.message ? this.state.form_state.stitches_next_thread_break.message : null}
                                            hint={this.props.translate('global.help.machine.stitches_next_thread_break')}>
			                        <Input 
			                            identifier="stitches_next_thread_break"
                                        ref="stitches_next_thread_break"
			                            type="number"
                                        minValue={1}
                                        maxValue={999999}
			                            value={this.state.form.stitches_next_thread_break}
			                            changed={this.inputChangedHandler}
                                        blurred={this.inputBlurredHandler}
                                        focused={this.inputFocusHandler}
                                        isRequired={true} />
			                    </InputRow>
			                	<InputRow label={this.props.translate('global.form.label.machine.thread_break_fixing_time')}   
                                            unit={this.props.translate('global.units.seconds')}   
                                            ref="thread_break_fixing_timeInputRow"
                                            state={this.state.form_state.thread_break_fixing_time.state ? this.state.form_state.thread_break_fixing_time.state : null} 
                                            tip={this.state.form_state.thread_break_fixing_time.message ? this.state.form_state.thread_break_fixing_time.message : null}
                                            hint={this.props.translate('global.help.machine.thread_break_fixing_time')}>
			                        <Input 
			                            identifier="thread_break_fixing_time"
                                        ref="thread_break_fixing_time"
			                            type="number"
                                        minValue={1}
                                        maxValue={1200}
			                            value={this.state.form.thread_break_fixing_time}
			                            changed={this.inputChangedHandler}
                                        blurred={this.inputBlurredHandler}
                                        focused={this.inputFocusHandler}
                                        isRequired={true} />
			                    </InputRow>
                                <InputRow label={this.props.translate('global.form.label.machine.maintenance_cost')}   
                                            unit={this.props.settingsCompany.settings.currency ? this.props.settingsCompany.settings.currency.symbol : ""}  
                                            ref="maintenance_costInputRow"
                                            state={this.state.form_state.maintenance_cost.state ? this.state.form_state.maintenance_cost.state : null} 
                                            tip={this.state.form_state.maintenance_cost.message ? this.state.form_state.maintenance_cost.message : null}
                                            hint={this.props.translate('global.help.machine.maintenance_cost')}>
                                    <Input 
                                        identifier="maintenance_cost"
                                        ref="maintenance_cost"
                                        type="number"
                                        minValue={0}
                                        maxValue={9999999}
                                        value={this.state.form.maintenance_cost}
                                        changed={this.inputChangedHandler}
                                        blurred={this.inputBlurredHandler}
                                        focused={this.inputFocusHandler}
                                        isRequired={true} />
                                </InputRow>
			                    <Button data-cy="create-new-machine-create-btn" value={this.props.translate('machinenewpage.step_2.submit')} type="submit" />                         
				            </GreyBox>
		                    ) : null }
							<Box align="center">
			                    <Text size="small" align="center">{this.props.translate('machinenewpage.secondary.text')}</Text>
			                    <Button data-cy="cancel-new-machine-btn" outerMargin="true" href="/machines" theme="light" value={this.props.translate('machinenewpage.secondary.label')}  width="320px" />
				        	</Box>
				        </Form>
				    </PageTemplate>
				)}
			</Aux>
  		)
	}
}

const mapStateToProps = state => {
    return {
        defaults: state.defaults,
        calculatorMachinesDefaults: state.calculatorMachinesDefaults,
        state: state.calculatorMachine,
        translate: getTranslate(state.locale),
        settingsCompany: state.calculatorSettingsCompany
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onCreateMachine: (formData) => dispatch(actionCreators.calculatorMachineCreate(formData)),
        onFetchMachinesDefaults: () => dispatch(actionCreators.calculatorMachinesDefaultsFetch()),
        onResetMachine: () => dispatch(actionCreators.calculatorMachineCreateReset()),
        onCalculatorMachineDuplicateCheck: (formData) => dispatch(actionCreators.calculatorMachineDuplicateCheck(formData)),
        onCalculatorMachineDuplicateCheckReset: () => dispatch(actionCreators.calculatorMachineDuplicateCheckReset())
    }
};
export default connect(mapStateToProps, mapDispatchToProps)(withErrorHandler(MachinesNewPage, axios));


// WEBPACK FOOTER //
// ./src/components/pages/MachinesNewPage/index.js